"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var _default = function _default() {
  var sheetMusicRuntimeInit = function sheetMusicRuntimeInit() {
    var retry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 6;
    return new Promise(function (resolve, reject) {
      var timeId = null;
      var retryCount = 0;

      if (window.SheetMusic.BarType) {
        resolve();
        return;
      }

      timeId = setInterval(function () {
        console.log("sheetMusicRuntimeInit \u91CD\u8BD5\u52A0\u8F7D ".concat(retryCount, "\u6B21"));

        if (window.SheetMusic.BarType) {
          clearInterval(timeId);
          resolve();
          return;
        }

        if (retryCount >= retry) {
          clearInterval(timeId);
          console.warn('sheetMuisc 库未正确初始化');
          reject('sheetMuisc 库未正确初始化');
          return;
        }

        retryCount++;
      }, 30000);
    });
  };

  var initSheetMusicBusiness = function initSheetMusicBusiness($el, options) {
    return sheetMusicRuntimeInit().then(function () {
      var sheetMusicBusiness = new window.SheetMusicBusiness.default($el, options);
      return sheetMusicBusiness;
    });
  };

  var loadSheetMusicToMeory = function loadSheetMusicToMeory($el, options, path) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var sheetMusicBusiness, result;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              sheetMusicBusiness = $el instanceof HTMLElement ? new window.SheetMusicBusiness.default($el, options) : $el;
              _context.next = 3;
              return sheetMusicBusiness.loadSheetToMemory(path);

            case 3:
              result = _context.sent;

              if (result) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return", false);

            case 6:
              return _context.abrupt("return", sheetMusicBusiness);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };

  var loadSheetMusic = function loadSheetMusic($el, options, path) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var sheetMusicBusiness, scaleCase, result;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              sheetMusicBusiness = $el instanceof HTMLElement ? new window.SheetMusicBusiness.default($el, options) : $el;
              scaleCase = options.userOptions.scaleCase;
              scaleCase && sheetMusicBusiness.scaleTo(scaleCase);
              _context2.next = 5;
              return sheetMusicBusiness.loadSheet(path);

            case 5:
              result = _context2.sent;

              if (result) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", false);

            case 8:
              return _context2.abrupt("return", sheetMusicBusiness);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  };

  var loadSheetMusicBySvgStr = function loadSheetMusicBySvgStr($el, options, path, svgApi, cloudPath) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var sheetMusicBusiness, result, scaleCase;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              sheetMusicBusiness = $el instanceof HTMLElement ? new window.SheetMusicBusiness.default($el, options) : $el;
              _context3.next = 3;
              return sheetMusicBusiness.loadSheetBySvgStr(path, svgApi, true, cloudPath);

            case 3:
              result = _context3.sent;

              if (result) {
                _context3.next = 6;
                break;
              }

              return _context3.abrupt("return", false);

            case 6:
              scaleCase = options.userOptions.scaleCase;
              scaleCase && sheetMusicBusiness.scaleTo(scaleCase);
              return _context3.abrupt("return", sheetMusicBusiness);

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
  };

  return {
    sheetMusicRuntimeInit: sheetMusicRuntimeInit,
    initSheetMusicBusiness: initSheetMusicBusiness,
    loadSheetMusic: loadSheetMusic,
    loadSheetMusicToMeory: loadSheetMusicToMeory,
    loadSheetMusicBySvgStr: loadSheetMusicBySvgStr
  };
};

exports.default = _default;